const PaymentLabels = {
  ALL: 'rdAll',
  ONLY_CASH: 'rdOnlyCash',
  CASH_AND_POINTS: 'rdOnlyPointsAndCashPoints'
}

export default PaymentLabels
